import React, {useState, useEffect, useRef, useContext} from "react";
import GenericTemplate from "../../templates/GenericTemplate";
import {
  options_state,
  apollo_useStyles,
  getModalStyle,
  options_state_new,
  options_state_edit
} from "../../atom/Apollo_styles_Beta";
import {CustomizedSnackbars} from "../../atom/Apollo_Mesasge";
import {Link, useHistory} from "react-router-dom";
import {ApolloContext} from "../../atom/Apollo_Context"
import {ApolloMessage} from "../../atom/Apollo_Mesasge";
import {ApolloAxios} from "../../atom/Apollo_ApiRequest3";
import {DataTableOptions, STORAGE_KEY} from "../../atom/Apollo_DataTable";
import {ROW_PER_PAGE_OPTIONS} from "../../common/Apollo_CommonConst";
import {Bars} from 'react-loader-spinner'
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import ChatIcon from '@material-ui/icons/Chat';
import Modal from "@material-ui/core/Modal";
import Card from "@material-ui/core/Card/Card";
import Box from "@material-ui/core/Box"
import Typography from "@material-ui/core/Typography";

import {MUIDataTableColumnDef} from "mui-datatables";
import ApolloPerformance from "../../molecule/Apollo_Performance";
import classNames from "classnames";
import {DATE_TIME_SUFFIX, BLANK} from "../CAMPAIGN/ms/common/CommonConst";
// メッセージ定義
import {
  GetMessage,
  UI_ACCOUNT_SUMMARY,
} from "../../atom/Apollo_MesasgeDefinition";
// 認証期間切れの処理
import {ApolloExpired} from "../../atom/Apollo_Expired";

import moment from 'moment';

import {
  AccountRawData,
  AccountTableData,
  MenuModalProps,
  AccountMenu,
} from "./SummaryModel"
import {LintChartStorageKey} from "./LineChart_Beta";

import {
  apollo_account_performances, apollo_account_performances_graph,
  apollo_account_platform_menu_path,
  isummary_path,
} from "../../atom/Apollo_links"
import {ApolloBreadcrumbs2, BreadcrumbsData} from "../../atom/Apollo_Breadcrumbs2";
import {Backdrop} from "@material-ui/core";

import {AccountSummaryColumns, CsvData} from "../../common/Apollo_CommonConst_Beta";
import {APOLLO_SYSTEM_ADMIN, APOLLO_PROFILE_SYSTEM_ADMIN, IsAuthorization} from "../../atom/Apollo_Authorization";
import {ApolloDateRangePicker} from "../../atom/Apollo_DateRangePicker";
import {
  APOLLO_PAGE_ID,
  applyApolloSharedColumnSettings,
  createApolloSharedTableOptions,
  getApolloSharedCalendar,
  saveApolloSharedCalendar,
} from "../../common/Apollo_LocalStorageSettings";

const valueToLabel = function (value: any, options: Array<{ value: any; label: string }>): string {
  let option = options.find(option => option.value === value)
  if (!option) {
    return "";
  } else {
    return option.label;
  }
};

/**
 * 日付形式に変換して返す
 * @param {moment.Moment} momentInstance
 * @returns {string}
 */
const toUtcIso8601str = (momentInstance: moment.Moment) => {
  return momentInstance
    .clone()
    // .utc()
    .format('YYYY-MM-DD')
}
const AccountSummary: React.FC = () => {
  const isAuthorization = IsAuthorization(APOLLO_SYSTEM_ADMIN, APOLLO_PROFILE_SYSTEM_ADMIN);
    
  const MIN_START_DATE = moment("2025-10-01");
  const DEFAULT_END_DATE = moment("2025-10-31");
  const LIMIT_DATE = moment("2025-09-30");

  // 条件判定
  const isBeforeLimit = moment().isSameOrBefore(LIMIT_DATE, "day");

  const defaultStartDate = !isAuthorization && isBeforeLimit
    ? toUtcIso8601str(MIN_START_DATE)
    : toUtcIso8601str(moment().startOf("month"));
  const defaultEndDate = !isAuthorization && isBeforeLimit
    ? toUtcIso8601str(DEFAULT_END_DATE)
    : toUtcIso8601str(moment().endOf("month"));
  const initialCalendar = getApolloSharedCalendar({
    startDate: defaultStartDate,
    endDate: defaultEndDate,
  });

  const [startDate, setStartDate] = useState(initialCalendar.startDate);
  const [endDate, setEndDate] = useState(initialCalendar.endDate);
  const [displayStartDate, setDisplayStartDate] = useState(initialCalendar.startDate)
  const [displayEndDate, setDisplayEndDate] = useState(initialCalendar.endDate)
  const [previousStartDate, setPreviousStartDate] = useState(initialCalendar.startDate)
  const [previousEndDate, setPreviousEndDate] = useState(initialCalendar.endDate)

  const [tableData, setTableData] = useState<AccountTableData>([])
  const [chartRawData, setChartRawData] = useState<AccountRawData>([])
  const [previousChartRawData, setPreviousChartRawData] = useState<AccountRawData>([])
  const [reflectAt, setReflectAt] = useState<string>("")
  const [loadingChart, setLoadingChart] = useState<boolean>(false)
  const [isAutoDisplayChecked, setIsAutoDisplayChecked]= useState<boolean>(false)
  const [isPreviousPeriodChecked, setIsPreviousPeriodChecked]= useState<boolean>(false)
  const [isPreviousPeriodDisabled, setIsPreviousPeriodDisabled]= useState<boolean>(false)
  const [isChartDataLoaded, setIsChartDataLoaded] = useState(false);
  const [isTableDataLoaded, setIsTableDataLoaded] = useState(false);

  const history = useHistory();
  const processing = useRef(false);
  const {state, dispatch} = useContext(ApolloContext);
  const {data, setmsg} = useContext(ApolloMessage);
  const breadcrumbsData: BreadcrumbsData = {
    categoryId: 22,
    breadId: 1,
    queries: [],
    menu: null,
    campaign: null,
    adgroup: null,
    advertisement: null,
    asset: null,
  }
  const classes = apollo_useStyles();

  function changeAccount(id: number) {

    if (processing.current) return;
    processing.current = true;
    if(id > tableData.length) return;
    const data = tableData[id];

    const accountGroupId = data.accountgroupId;
    const accountId = data.id;
    let roleAuthorization = 0;
    let customSegment = 1
    let geoSegment = 1
    let trackerId = "";
    for (const item of state.apolloList) {
      if (item.accountGroup.id === accountGroupId) {
        roleAuthorization = item.accountGroup.roleAuthorization;
        customSegment = item.accountGroup.customSegment;
        geoSegment = item.accountGroup.geoSegment;
        item.accountList.find((v) => {
          if (v.id === accountId) {
            trackerId = v.trackerId;
          }
        });
        break;
      }
    }

    dispatch({
      type: "changeAccount",
      payload: {
        ...state,
        current: {
          ...state.current,
          accountGroupId: accountGroupId,
          accountGroupName: data.accountgroupName,
          accountId: accountId,
          accountName: data.accountName,
          trackerId: trackerId,
          roleAuthorization: roleAuthorization,
          customSegment: customSegment,
          geoSegment: geoSegment,
        }
      }
    });

    history.push(isummary_path);
  }

  const [clickedAccountId, setClickedAccountId] = useState<number>(0)
  const [open, setOpen] = useState<boolean>(false);

  const userId = state.userprofile.userId

  // 期間変更比較
  type BeforeStartEndDate = {
    startDate: string,
    endDate: string,
  }
  const currentBeforeDate = React.useRef<BeforeStartEndDate>({
    startDate: "",
    endDate: "",
  });
  const previousBeforeDate = React.useRef<BeforeStartEndDate>({
    startDate: "",
    endDate: "",
  });

  const options: DataTableOptions = {
    print: false,
    downloadOptions: {
      filename: `summary_${moment(startDate).format("YYYYMMDD")}_${moment(endDate).format("YYYYMMDD")}.csv`,
      separator: ",",
      filterOptions: {
        useDisplayedColumnsOnly: false,
        useDisplayedRowsOnly: true,
      }
    },
    onDownload: (buildHead: any, buildBody: any, columns: any, data: any) => {
      const csvData = formatCsvData(data, tableData);
      return "\uFEFF" + buildHead(AccountSummaryColumns) + buildBody(csvData);
    },
    jumpToPage: true,
    rowsPerPageOptions: ROW_PER_PAGE_OPTIONS.HOME_AND_MAIN_LEVELS,
    elevation: 0,
    selectToolbarPlacement: "above",
    filterType: "multiselect",
    customToolbarSelect: () => undefined,
    customFilterDialogFooter: () => <Box width={400}/>,
  }

  const columns: MUIDataTableColumnDef[] = [
    {
      name: "id",
      label: "広告主アカウントID",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
      }
    },
    {
      name: "accountName",
      label: "広告主アカウント名",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({style: {minWidth: "10rem"}}),
        customBodyRenderLite: (idx: number) => {
          return (
            <Link onClick={() => {
              changeAccount(idx)
            }}
                  to="#">{tableData[idx].accountName}</Link>
          )
        }
      }
    },
    {
      name: "accountgroupId",
      label: "アカウントグループID",
      options: {
        filter: false,
        sort: true,
        display: localStorage.getItem(STORAGE_KEY.ACCOUNT_SUMMARY) ? undefined : false,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
      }
    },
    {
      name: "accountgroupName",
      label: "アカウントグループ名",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({style: {minWidth: "10rem"}}),
      }
    },
    {
      name: "status",
      label: "ステータス",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value: number) => valueToLabel(value, options_state_new),
        setCellProps: () => ({style: {minWidth: "8rem"}}),
      }
    },
    {
      name: "",
      label: "メニュー開設",
      options: {
        filter: false,
        sort: false,
        apolloColumnId: "menuOpen",
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRenderLite: (idx: number) => {
          return (
            <IconButton aria-label="delete" onClick={() => {
              setOpen(true);
              setClickedAccountId(tableData[idx].id ?? 0)
            }}>
              <ChatIcon/>
            </IconButton>
          )
        }
      } as any,
    },
    {
      name: "cost",
      label: "cost",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => "¥" + value.toLocaleString(),
      }
    },
    {
      name: "imp",
      label: "imp",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => value.toLocaleString(),
      }
    },
    {
      name: "vimp",
      label: "vimp",
      options: {
        filter: false,
        sort: true,
        display: localStorage.getItem(STORAGE_KEY.ACCOUNT_SUMMARY) ? undefined : false,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => value.toLocaleString(),
      }
    },
    {
      name: "click",
      label: "click",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => value.toLocaleString(),
      }
    },
    {
      name: "ctr",
      label: "CTR",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => (Math.floor((Math.round(value * 1000000) / 1000000) * 100 * 100) / 100).toFixed(2) + "%",
      }
    },
    {
      name: "vctr",
      label: "vCTR",
      options: {
        filter: false,
        sort: true,
        display: localStorage.getItem(STORAGE_KEY.ACCOUNT_SUMMARY) ? undefined : false,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => (Math.floor((Math.round(value * 1000000) / 1000000) * 100 * 100) / 100).toFixed(2) + "%",
      }
    },
    {
      name: "cpc",
      label: "平均CPC",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => "¥" + value.toLocaleString(),
      }
    },
    {
      name: "cpm",
      label: "CPM",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => "¥" + value.toLocaleString(),
      }
    },
    {
      name: "trackingPointCvTotal",
      label: "CV(合計)",
      options: {
        filter: false,
        sort: true,
        display: localStorage.getItem(STORAGE_KEY.ACCOUNT_SUMMARY) ? undefined : false,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => value?.toLocaleString(),
      }
    },
    {
      name: "trackingPointCvClickThrough",
      label: "ラストクリックCV(合計)",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => value?.toLocaleString(),
      }
    },
    {
      name: "trackingPointCvAssist",
      label: "アシストクリックCV(合計)",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => value?.toLocaleString(),
      }
    },
    {
      name: "trackingPointCvrTotal",
      label: "CVR(合計)",
      options: {
        filter: false,
        sort: true,
        display: localStorage.getItem(STORAGE_KEY.ACCOUNT_SUMMARY) ? undefined : false,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => (Math.floor((Math.round(value * 1000000) / 1000000) * 100 * 100) / 100).toFixed(2) + "%",
      }
    },
    {
      name: "trackingPointCvrClickThrough",
      label: "ラストクリックCVR(合計)",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => (Math.floor((Math.round(value * 1000000) / 1000000) * 100 * 100) / 100).toFixed(2) + "%",
      }
    },
    {
      name: "trackingPointCvrAssist",
      label: "アシストクリックCVR(合計)",
      options: {
        filter: false,
        sort: true,
        display: localStorage.getItem(STORAGE_KEY.ACCOUNT_SUMMARY) ? undefined : false,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => (Math.floor((Math.round(value * 1000000) / 1000000) * 100 * 100) / 100).toFixed(2) + "%",
      }
    },
    {
      name: "trackingPointCpaTotal",
      label: "CPA(合計)",
      options: {
        filter: false,
        sort: true,
        display: localStorage.getItem(STORAGE_KEY.ACCOUNT_SUMMARY) ? undefined : false,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => "¥" + (Math.trunc(value??0)).toLocaleString(),
      }
    },
    {
      name: "trackingPointCpaClickThrough",
      label: "ラストクリックCPA(合計)",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => "¥" + (Math.trunc(value??0)).toLocaleString(),
      }
    },
    {
      name: "trackingPointCpaAssist",
      label: "アシストクリックCPA(合計)",
      options: {
        filter: false,
        sort: true,
        display: localStorage.getItem(STORAGE_KEY.ACCOUNT_SUMMARY) ? undefined : false,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => "¥" + (Math.trunc(value??0)).toLocaleString(),
      }
    },
    {
      name: "lastCvTotal",
      label: "最適化ポイントCV",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => value?.toLocaleString(),
      }
    },
    {
      name: "lastCvrTotal",
      label: "最適化ポイントCVR",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => (Math.floor((Math.round(value * 1000000) / 1000000) * 100 * 100) / 100).toFixed(2) + "%",
      }
    },
    {
      name: "lastCpaTotal",
      label: "最適化ポイントCPA",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => "¥" + (Math.trunc(value??0)).toLocaleString(),
      }
    },
  ];

  const columnsWithLocalStorage = applyApolloSharedColumnSettings(columns, {pageId: APOLLO_PAGE_ID.HOME, data: tableData});
  const optionsWithLocalStorage = createApolloSharedTableOptions(options, {
    pageId: APOLLO_PAGE_ID.HOME,
    columns: columnsWithLocalStorage,
  }) as DataTableOptions;

  useEffect(() => {
    saveApolloSharedCalendar(startDate, endDate);
  }, [startDate, endDate]);

  useEffect(() => {
    let clean = false
    setIsTableDataLoaded(false);

    const fetchTableData = async () => {
      const url = `${apollo_account_performances}/${userId}?Start=${startDate}&End=${endDate}`
      await ApolloAxios.get(url).then((response) => {
        if (!clean) {
          if (!response.data.result.tableData) {
            setTableData([])
          } else {
            setTableData(response.data.result.tableData)
          }

          if (!response.data.result.reflectAt) {
            setReflectAt("")
          } else {
            setReflectAt(response.data.result.reflectAt)
          }
        }
      }).catch(err => {
        console.log(err)
        // 認証期間切れ判定とエラーメッセージ表示
        if (!ApolloExpired(err, GetMessage("0",UI_ACCOUNT_SUMMARY,"E","0"), data, setmsg, history)) {
          // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
        }
      }).finally(() => {
        setmsg({
          type: "loading",
          payload: {
            ...data,
            loading: false
          }
        })
      });
    }

    const fetchTable = async () => {
      setmsg({
        type: "loading",
        payload: {
          ...data,
          loading: true
        }
      })

      await Promise.all(
        [fetchTableData()]
      ).finally(() => {
        setmsg({
          type: "loading",
          payload: {
            ...data,
            loading: false
          }
        })
        setProgress(false);
        setIsTableDataLoaded(true);
      })
    }
    fetchTable();

    // クリーンアップ
    const cleanup = () => {
      clean = true;
    };
    return cleanup;
  }, [startDate, endDate, userId]);

  useEffect(() => {
    if (!isTableDataLoaded || !isAutoDisplayChecked) return
    fetchChartData();
  }, [isTableDataLoaded, isAutoDisplayChecked, isPreviousPeriodChecked]);

  const fetchChartData = () => {
    if(loadingChart) return;
    setLoadingChart(true);
    setIsChartDataLoaded(false);
    setDisplayStartDate(startDate);
    setDisplayEndDate(endDate);
    const start = moment(startDate);
    const end = moment(endDate);
    const diffDays = end.diff(start, 'days') + 1;
    const previousStart = start.subtract(diffDays, 'days').format('YYYY-MM-DD');
    const previousEnd = end.subtract(diffDays, 'days').format('YYYY-MM-DD');
    setPreviousStartDate(previousStart);
    setPreviousEndDate(previousEnd);

    const fetchChart = async () => {
      if (startDate === currentBeforeDate.current.startDate && endDate === currentBeforeDate.current.endDate) return;
      const url = `${apollo_account_performances_graph}/${userId}?Start=${startDate}&End=${endDate}`
      await ApolloAxios.get(url).then((response) => {
        if (!response.data.result.chartData) {
          setChartRawData([])
        } else {
          setChartRawData(response.data.result.chartData)
        }
        currentBeforeDate.current = {startDate: startDate, endDate: endDate,}
      }).catch(err => {
        // 認証期間切れ判定とエラーメッセージ表示
        if (!ApolloExpired(err, GetMessage("0",UI_ACCOUNT_SUMMARY,"E","1"), data, setmsg, history)) {
          // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
        }
      }).finally(() => {
      });
    }

    const fetchPreviousChart = async () => {
      if (!isPreviousPeriodChecked) return;
      if (startDate === previousBeforeDate.current.startDate && endDate === previousBeforeDate.current.endDate) return;
      setIsPreviousPeriodDisabled(true);
      const urlPrevious = `${apollo_account_performances_graph}/${userId}?Start=${previousStart}&End=${previousEnd}`
      await ApolloAxios.get(urlPrevious).then((response) => {
        if (!response.data.result.chartData) {
          setPreviousChartRawData([])
        } else {
          setPreviousChartRawData(response.data.result.chartData)
        }
        previousBeforeDate.current = {startDate: startDate, endDate: endDate,}
      }).catch(err => {
        // 認証期間切れ判定とエラーメッセージ表示
        if (!ApolloExpired(err, GetMessage("0",UI_ACCOUNT_SUMMARY,"E","1"), data, setmsg, history)) {
          // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
        }
      }).finally(() => {
        setIsPreviousPeriodDisabled(false);
      });
    }

    const fetchAll = async () => {
      await Promise.all(
        [fetchChart(), fetchPreviousChart()]
      ).finally(() => {
        setmsg({
          type: "loading",
          payload: {
            ...data,
            loading: false
          }
        })
        setLoadingChart(false);
        setIsChartDataLoaded(true);
      })
    }
    fetchAll();
  }

  const [progress, setProgress] = useState(true);

  return (
    <GenericTemplate title="">
      <Backdrop className={classes.backdrop2} open={progress}>
        <Bars color="#00BFFF" height={80} width={80}/>
      </Backdrop>
      <CustomizedSnackbars/>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <ApolloBreadcrumbs2 data={breadcrumbsData}/>
        </Grid>
        <Grid item xs={4}>
          <ApolloDateRangePicker
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            {...(!isAuthorization && { startMinDate: new Date("2025-10-01T00:00:00") })}
            // endMaxDate={moment().endOf("month").toDate()}
          />
        </Grid>
        <Grid item xs={8}>
        </Grid>
      </Grid>
      <ApolloPerformance
        startDate={displayStartDate}
        endDate={displayEndDate}
        previousStartDate={previousStartDate}
        previousEndDate={previousEndDate}
        dailyPerformanceData={chartRawData.map(value => value.performances)}
        previousDailyPerformanceData={previousChartRawData.map(value => value.performances)}
        data={tableData}
        columns={columnsWithLocalStorage}
        options={optionsWithLocalStorage}
        storageKeyGraph1={LintChartStorageKey.AccountSummaryGraph1}
        storageKeyGraph2={LintChartStorageKey.AccountSummaryGraph2}
        fileName={`chart_summary_${moment(startDate).format("YYYYMMDD")}_${moment(endDate).format("YYYYMMDD")}.csv`}
        loadingChart={loadingChart}
        onLoadChart={fetchChartData}
        isAutoDisplayChecked={isAutoDisplayChecked}
        setIsAutoDisplayChecked={setIsAutoDisplayChecked}
        isPreviousPeriodChecked={isPreviousPeriodChecked}
        setIsPreviousPeriodChecked={setIsPreviousPeriodChecked}
        isPreviousPeriodDisabled={isPreviousPeriodDisabled}
        isChartDataLoaded={isChartDataLoaded}
        title={
          <React.Fragment>
            <p style={{fontSize: "20px"}}>アカウント別実績</p>
            <p style={{fontSize: "15px"}}>
              {
                "実績値取得日時: " +
                (
                  reflectAt
                    ? moment(reflectAt.replace(DATE_TIME_SUFFIX, BLANK)).format("YYYY-MM-DD HH:mm:ss")
                    : BLANK
                )
              }
            </p>
          </React.Fragment>
        }
      />
      <Modal open={open} onClose={() => setOpen(false)}>
        <p>test</p>
      </Modal>
      <MenuModal accountId={clickedAccountId} open={open} setOpen={setOpen}/>
    </GenericTemplate>
  );
};

const MenuModal: React.FC<MenuModalProps> = (props) => {
  const {data, setmsg} = React.useContext(ApolloMessage);
  const [accountMenus, setAccountMenus] = useState<AccountMenu[]>([])

  const classes = apollo_useStyles();
  const [modalStyle] = React.useState(getModalStyle);
  const flameClass = classNames(classes.root, classes.flame);
  // リダイレクト(認証期間切れの場合にリダイレクトするため)
  const history = useHistory();

  // API取得
  useEffect(() => {
    // リクエスト前の値をクリア
    setAccountMenus([])

    // AccountIDが設定されていない場合は、リクエストを送らない
    if (props.accountId !== 0) {
      // 広告主アカウントメニュー取得
      const url = apollo_account_platform_menu_path + "/" + props.accountId;
      ApolloAxios.get(url).then(response => {

        // メニュー情報が1つもない場合
        if (!response.data.result || response.data.result?.length === 0) {
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "info",
              message: "広告主アカウントメニュー情報が見つかりませんでした"
            }
          });
          return
        }

        // 広告主アカウントメニューを設定
        setAccountMenus(response.data.result)
      }).catch(err => {
        // エラー時、前の値が表示されないように広告主アカウントメニューを空配列で設定
        setAccountMenus([])
        // 認証期間切れ判定とエラーメッセージ表示
        if (!ApolloExpired(err, GetMessage("0",UI_ACCOUNT_SUMMARY,"E","2"), data, setmsg, history)) {
          // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
        }
      })
    }
  }, [props.accountId]);

  return (
    <Modal open={props.open} onClose={() => props.setOpen(false)}>
      <div style={modalStyle} className={classes.accountpaper}>
        <Card className={classes.root} square variant="outlined">
          <Box m={3} className={flameClass}>
            {accountMenus?.map((accountMenu, index) => (
              <Grid container spacing={3} key={index}>
                <Grid item xs={6}>
                  <Typography variant="subtitle1" gutterBottom component="div">{accountMenu.menuName}:</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="subtitle1" gutterBottom
                              component="div">{valueToLabel(accountMenu.useStatus, options_state)}</Typography>
                </Grid>
              </Grid>
            ))}
          </Box>
        </Card>
      </div>
    </Modal>
  )
}

const formatCsvData = (data: any[], tableData: AccountTableData): CsvData[] => {
  const dataList: CsvData[] = [];
  data?.map((v: { index: any, data: any[] }) => {
      if (!v.data || v.data.length === 0) return;
      const values = tableData.filter((td) => td.id === v.data[0]);
      if (!values || values.length === 0) return;
      const d = values[0];
      const list: CsvData = {
        index: v.index,
        data: [
          d.id,
          d.accountName,
          d.accountgroupId,
          d.accountgroupName,
          valueToLabel(d.status, options_state_edit),
          `￥${d.cost}`,
          d.imp,
          d.vimp,
          d.click,
          `${(Math.floor((Math.round(d.ctr * 1000000) / 1000000) * 100 * 100) / 100).toFixed(2)}%`,
          `${(Math.floor((Math.round(d.vctr * 1000000) / 1000000) * 100 * 100) / 100).toFixed(2)}%`,
          `￥${d.cpc}`,
          `￥${d.cpm}`,
          d.trackingPointCvTotal,
          d.trackingPointCvClickThrough,
          d.trackingPointCvAssist,
          `${(Math.floor((Math.round(d.trackingPointCvrTotal * 1000000) / 1000000) * 100 * 100) / 100).toFixed(2)}%`,
          `${(Math.floor((Math.round(d.trackingPointCvrClickThrough * 1000000) / 1000000) * 100 * 100) / 100).toFixed(2)}%`,
          `${(Math.floor((Math.round(d.trackingPointCvrAssist * 1000000) / 1000000) * 100 * 100) / 100).toFixed(2)}%`,
          `¥${(Math.trunc(d.trackingPointCpaTotal??0))}`,
          `¥${(Math.trunc(d.trackingPointCpaClickThrough??0))}`,
          `¥${(Math.trunc(d.trackingPointCpaAssist??0))}`,
          d.lastCvTotal,
          `${(Math.floor((Math.round(d.lastCvrTotal * 1000000) / 1000000) * 100 * 100) / 100).toFixed(2)}%`,
          `¥${(Math.trunc(d.lastCpaTotal??0))}`,
        ],
      };
      dataList.push(list);
    }
  );
  return dataList;
}

export default AccountSummary;
